import PropTypes from 'prop-types';
export var ListBoxType = PropTypes.oneOf(['default', 'inline']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/ListBox/ListBoxPropTypes.js
// module id = 576
// module chunks = 0